import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { projectKeys } from '../projectKeys'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useAddProjectDocumentEngineTemplates = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['addProjectDocumentEngineTemplates']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...projectKeys.addProjectDocumentEngineTemplates,
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.byId({ projectId: variables.projectId })._ctx
          .projectDocumentEngineTemplates._def,
      })
    },
  })
}
